import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { changeAdherenceSortBy, fetchAdherences } from '../actions';

import SearchFilters from './filters/search-filters';
import Pagination from './filters/pagination';

class AdheringParties extends Component {
	componentWillMount() {
		if ( 'undefined' !== typeof ProtocolISDAId ) {
			this.props.fetchAdherences( ProtocolISDAId );
		}
	}

	componentWillUpdate( nextProps ) {
		if ( this.props.searchTerm !== nextProps.searchTerm || this.props.pagination.perPage !== nextProps.pagination.perPage || this.props.pagination.pageNum !== nextProps.pagination.pageNum || this.props.orderBy.orderby !== nextProps.orderBy.orderby || this.props.orderBy.order !== nextProps.orderBy.order ) {
			this.props.fetchAdherences( ProtocolISDAId, nextProps.pagination.perPage, nextProps.pagination.pageNum, nextProps.searchTerm );
		}
	}

	ifAdherenceLink( adherence ) {
		if ( adherence.link ) {
			return <a href={ adherence.link }>{ adherence.participant }</a>;
		}

		return <span>adherence.participant</span>;
	}

	ifRevocation( adherence ) {
		if ( adherence.revoke_date !== '' && adherence.revoke_link !== '' ) {
		 return(
			<div>
			<a href={ adherence.revoke_link } target="_blank"><strong>Revocation Notice:</strong> Effective as of { adherence.revoke_date }</a>
		</div>
		 );
		} else if ( adherence.revoke_date !== '' ) {
			return(
				<div>
					<strong>Revocation Notice:</strong> Effective as of { adherence.revoke_date }
				</div>
			);
		}
	}

	companyNameUpdates( adherence ) {
		if ( Object.keys( adherence.company_name_doc_updated ).length > 0 ) {
			return (<Fragment>
					<strong>Name Change: </strong>
					{ adherence.company_name_doc_updated.name.map( ( name, index ) => (
						<a key={ index }
						   href={ adherence.company_name_doc_updated.link[ index ] }
						   className="rpadding"
						   target="_blank" rel="noopener noreferrer">
							{ name };
						</a>
					) ) }
				</Fragment>
			);
		}
	}

	renderTableRows( adherences ) {
		if ( adherences.status && 'error' === adherences.status ) {
			// No results, keep table clear
		} else {
			return adherences.map( adherence => {
				return (<tr key={ adherence.id } className="adh-data-row">
						<td width="60%">
							{ this.ifAdherenceLink( adherence ) }
							{ this.ifRevocation( adherence ) }
							<span className="show">
								{ this.companyNameUpdates( adherence ) }
							</span>
						</td>
						<td>{ adherence.adherence_dates.last_submission }</td>
						<td>{ adherence.adherence_dates.acceptance_date }</td>
					</tr>
				);
			} );
		}
	}

	clickHeading( event ) {
		let orderBy = event.target.getAttribute( 'data-heading' );
		this.props.changeAdherenceSortBy( orderBy );
	}

	getSortArrow( heading ) {
		if ( this.props.orderBy.orderby === heading ) {
			return `glyphicon-arrow-${('asc' === this.props.orderBy.order
			                          ) ? 'up' : 'down'}`;
		}
	}

	render() {
		const searchType = 'adh-list';
		return (<div>
				<SearchFilters searchType={ searchType } />
				<table id="protocol-adherence-parties" className="table-style" cellSpacing="0" width="100%">
					<thead>
					<tr className="table-style-header">
						<th className='has-sort' onClick={ this.clickHeading.bind( this ) } data-heading="participant">Adhering Organization
							<span className={ `glyphicon ${this.getSortArrow( 'participant' )}` } aria-hidden="true"></span>
						</th>
						<th className='has-sort' onClick={ this.clickHeading.bind( this ) } data-heading="accepted">Last Submission<span className={ `glyphicon ${this.getSortArrow( 'accepted' )}` } aria-hidden="true"></span>
						</th>
						<th className='has-sort' onClick={ this.clickHeading.bind( this ) } data-heading="accepted">Acceptance Date
							<span className={ `glyphicon ${this.getSortArrow( 'accepted' )}` } aria-hidden="true"></span>
						</th>
					</tr>
					</thead>
					<tbody>{ this.renderTableRows( this.props.adherences ) }</tbody>
				</table>
				<Pagination />
			</div>
		);
	}
}

function mapStateToProps( { adherences, pagination, searchTerm, orderBy } ) {
	return { adherences, pagination, searchTerm, orderBy };
}

export default connect( mapStateToProps, {
	fetchAdherences, changeAdherenceSortBy
} )( AdheringParties );